<div *ngIf="loading" class="text-center">
    <p-progressSpinner></p-progressSpinner>
  </div>
  
  <div class="field grid">
    <label class="col-fixed"></label>
    <p-orderList [ngClass]="{'disabled-ordering': selectedFaqCategories?.length < 1}" [value]="faqCategories" [(selection)]="selectedFaqCategories" (onReorder)="onReorder()" [dragdrop]="true">
        <ng-template let-category pTemplate="item">
            <div>
                <h5 class="mb-2">{{category.Title}}</h5>
            </div>
        </ng-template>
    </p-orderList>
    <div class="sys-settings-action-buttons">
        <button id="add-button" type="button" pButton (click)="showAddDialog()" label="Add"></button>
        <button id="edit-button" type="button" pButton [disabled]="!showEditButton()" (click)="showEditDialog()" label="Edit"></button>
        <button id="delete-button" type="button" pButton [disabled]="!showDeleteButton()" (click)="onCategoryDelete()" label="Delete"></button>
      </div>
  </div>

<faq-category-dialog (onSave)="handleFaqCategorySave($event)" [faqCategories] = "faqCategories"></faq-category-dialog>